import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import FragmentWrapper from 'graphql-client/FragmentWrapper';

import {FullExecutionSample} from './__generated/FullExecutionSample';

const FULL_EXECUTION_SAMPLE_FRAGMENT = gql`
  fragment FullExecutionSample on ExecutionSampleNode {
    ...ExecutionSampleGraphQL
    batch {
      ...BatchGraphQL
    }
    bioentity {
      ...BioentitySummaryGraphQL
    }
    container {
      ...ContainerGraphQL
    }
  }
  ${getFragmentWrapper('Batch').fragment}
  ${getFragmentWrapper('ExecutionSample').fragment}
  ${getFragmentWrapper('BioentitySummary').fragment}
  ${getFragmentWrapper('Container').fragment}
`;

export const FullExecutionSampleFragment: FragmentWrapper<FullExecutionSample> = {
  fragment: FULL_EXECUTION_SAMPLE_FRAGMENT,
  fragmentName: 'FullExecutionSample',
};
